import { Instagram, Facebook, Youtube } from "lucide-react";
import { SOCIALS } from "../../lib/content";

const PinterestIcon = ({ size = 18 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12c0 4.24 2.64 7.86 6.36 9.32-.09-.79-.17-2 .03-2.86.18-.78 1.17-4.97 1.17-4.97s-.3-.6-.3-1.48c0-1.39.8-2.42 1.8-2.42.85 0 1.26.64 1.26 1.4 0 .85-.54 2.13-.82 3.31-.24.99.5 1.8 1.47 1.8 1.77 0 3.13-1.87 3.13-4.56 0-2.38-1.71-4.05-4.16-4.05-2.83 0-4.5 2.12-4.5 4.32 0 .85.33 1.77.74 2.27.08.1.09.19.07.29-.08.32-.25 1-.28 1.14-.04.18-.15.22-.34.13-1.25-.58-2.03-2.4-2.03-3.87 0-3.15 2.29-6.04 6.6-6.04 3.46 0 6.16 2.47 6.16 5.77 0 3.44-2.17 6.21-5.18 6.21-1.01 0-1.97-.53-2.29-1.15l-.62 2.37c-.23.86-.83 1.94-1.24 2.6.94.29 1.92.44 2.95.44 5.52 0 10-4.48 10-10S17.52 2 12 2z" />
  </svg>
);

const ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  youtube: Youtube,
  pinterest: PinterestIcon,
};

export const SocialLinks = ({ size = 18, className = "", gap = "gap-4" }) => (
  <div className={`flex items-center ${gap} ${className}`}>
    {SOCIALS.map((s) => {
      const Icon = ICONS[s.icon];
      return (
        <a
          key={s.icon}
          data-testid={`social-${s.icon}`}
          href={s.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={s.label}
          className="text-white/60 hover:text-gold transition-colors duration-300"
        >
          <Icon size={size} />
        </a>
      );
    })}
  </div>
);
